export const normalizeOptions = (opts) => {
  if (!opts) return {};

  return Object.keys(opts)
    .sort()
    .reduce((acc, k) => {
      acc[k.trim().toLowerCase()] = String(opts[k]).trim();
      return acc;
    }, {});
};

export const areOptionsExactlyEqual = (a, b) => {
  const na = normalizeOptions(a);
  const nb = normalizeOptions(b);

  const ak = Object.keys(na);
  const bk = Object.keys(nb);

  if (ak.length !== bk.length) return false;

  return ak.every((k) => k in nb && na[k] === nb[k]);
};

export const getDefaultSelectedOptions = (productDetails) => {
  const defaults = {};

  if (!productDetails?.ProductOptions?.length) return defaults;

  productDetails.ProductOptions.forEach((option) => {
    if (option.ProductOptionValues?.length) {
      defaults[option.OptionName] = option.ProductOptionValues[0].ValueName;
    }
  });

  return defaults;
};

export const addToCart = ({
  productDetails,
  selectedOptions,
  quantity = 1,
  fileList,
  messageApi,
}) => {
  if (!productDetails?.Id) return;

  const normalizedSelected = normalizeOptions(selectedOptions);

  const specialKey = JSON.stringify({
    productId: productDetails.Id,
    options: normalizedSelected,
  });

  const cartItem = {
    productId: productDetails.Id,
    productName: productDetails.ProductName,
    descriptions: productDetails.Description,
    sku: productDetails.Sku,
    quantity,
    firstImage: fileList?.[0]?.url ?? null,
    options: normalizedSelected,
    specialKey,
  };

  const cartItems = JSON.parse(localStorage.getItem("cartItems")) || [];

  const idx = cartItems.findIndex(
    (item) =>
      item.productId === cartItem.productId &&
      areOptionsExactlyEqual(item.options, cartItem.options),
  );

  if (idx > -1) {
    cartItems[idx].quantity += quantity;

    messageApi?.success?.({
      content: "Product quantity updated successfully!",
      duration: 2,
    });
  } else {
    cartItems.push(cartItem);

    messageApi?.success?.({
      content: "Product added to cart successfully!",
      duration: 2,
    });
  }

  localStorage.setItem("cartItems", JSON.stringify(cartItems));
  window.dispatchEvent(new Event("cartUpdated"));
};
